import React, { useState, useEffect } from 'react';

import { copyToClipboard, makeRelativeTimeString } from './util.js';
import { endpoints } from './endpoints.js';
import { fetchWithJWT } from './requests.js';

import "./Keys.scss";

function Keys() {
  const [data, setData] = useState([]);
  const [searchString, setSearchString] = useState("");
  const [searchStringRequest, setSearchStringRequest] = useState("");
  const [searchTask, setSearchTask] = useState(null);
  const [onlyActive, setOnlyActive] = useState(true);
  const [refresh, setRefresh] = useState(0);

  useEffect(() => {
    loadData();
  }, [searchStringRequest, onlyActive, refresh]);

  function loadData() {
    let paramsObj = {"only_active": onlyActive};

    if (searchStringRequest !== "") {
      paramsObj["search"] = searchStringRequest;
    }

    const params = new URLSearchParams(paramsObj);
    let url = `${endpoints.getKeys}?${params}`;
    fetchWithJWT(url, "GET", null,
      (data) => {
        if (Array.isArray(data)) {
          setData(data);
        } else {
          setData([]);
        }
      },
      console.log,
    )
  }

  const handleOnlyActive = (event) => {
    let checked = event.target.checked;
    setOnlyActive(checked);
  }

  const handleSearchChange = (event) => {
    let search_term = event.target.value;

    if (searchTask != null) {
      clearTimeout(searchTask);
    }

    let task = setTimeout(() => {
      setSearchStringRequest(search_term);
      setSearchTask(null);
    }, 250);
    setSearchTask(task);
    setSearchString(search_term);
  };

  const handleDeleteKey = (id) => {
    let url = `${endpoints.deleteKey}/${id}`;
    fetchWithJWT(url, "DELETE", null,
      console.log,
      console.log,
    )
    setRefresh(refresh+1);
  };

  const copy = (key) => {
    copyToClipboard(key);
  }

  return (
    <div className="container block">
      <div className="level">
        <div className="level-left">
          <div className="level-item">
            <h2 className="title has-text-weight is-4 honey-text-font-family honey-text-common">
              Keys
            </h2>
          </div>
        </div>
        <div className="level-right">
          <div className="level-item">
            <label className="checkbox">
              <input type="checkbox" checked={onlyActive} onChange={handleOnlyActive} />
              <span className="honey-text-common">Only Active</span>
            </label>
          </div>
          <div className="level-item">
            <input
              className="input honey-input-focus-color"
              type="text"
              name="Search"
              placeholder="Search key"
              value={searchString}
              onChange={handleSearchChange}
            />
          </div>
        </div>
      </div>
      <div className="table-container honey-round-border honey-table-overflow">
        <table className="table is-fullwidth">
          <thead>
            <tr>
              <th>Timestamp</th>
              <th>Key</th>
              <th>Valid</th>
              <th>Tier</th>
              <th className="has-text-right">Actions</th>
            </tr>
          </thead>
          <tbody>
            {data.map((ele, index) => (
              <tr key={index} className={ele.Valid ? "" : "honey-key-invalid"}>
                <td>{makeRelativeTimeString(ele.CreatedAt, true)}</td>
                <td>
                  <span className="icon honey-key-copy-icon" onClick={() => {copy(ele.Key)}}>
                    <i className="fas fa-copy"></i>
                  </span>
                  <span title={ele.Key} className="honey-text-font-monospace">{ele.Key.slice(0, 10) + "..."}</span>
                </td>
                <td>{ele.Valid ? "TRUE" : "FALSE" }</td>
                <td>{makeTierBadge(ele.TierID)}</td>
                <td className="has-text-right">
                  {ele.Valid ? (
                    <span className="icon honey-key-invalid-icon" onClick={() => {handleDeleteKey(ele.ID)}}>
                      <i className="fas fa-trash"></i>
                    </span>
                  ) : (
                    <span>n/a</span>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

function makeTierBadge(tier_id) {
  switch(tier_id) {
    case 1:
      return (
        <span className="tag is-primary">Admin</span>
      )
    case 2:
      return (
        <span className="tag is-info">Enterprise</span>
      )
    case 3:
      return (
        <span className="tag is-success">Pro</span>
      )
    case 4:
      return (
        <span className="tag">Basic</span>
      )
    default:
      return (
        <span className="tag is-danger">Unknown</span>
      )
  }
}

export default Keys;
